// Mirrors backend TemplateCategory: the workflow step a tenant template belongs to.
export enum TemplateCategoryEnum {
  ACTION_PLAN = 'ActionPlan',
  DECISION = 'Decision',
  CONVERSATION = 'Conversation',
}
